export default __webpack_public_path__ + "static/media/test.bbe1ccf5.JPG";